import { SetStateAction, useCallback, useContext } from "react";

import { CustomerClassification } from "../../interfaces/CustomerClassification";

import { IndexerValueTypes } from "../../interfaces/IndexerValueTypes";

import { CustomerClassificationContext } from "./customer-classification-context";
import { CustomerClassificationHookType } from "./customer-classification-context.types";

export const useCustomerClassification = (): CustomerClassificationHookType => {
  const { customerClassification, setCustomerClassification } = useContext(
    CustomerClassificationContext
  );

  const createCustomerClassification = useCallback(
    (newCustomerClassification: CustomerClassification): void => {
      setCustomerClassification(newCustomerClassification);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customerClassification]
  );

  const onChangeCustomerClassification = useCallback(
    (key: string, newValue: IndexerValueTypes): void => {
      setCustomerClassification({
        ...customerClassification,

        [key]: newValue,
      } as SetStateAction<CustomerClassification | null>);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customerClassification]
  );

  const deleteCustomerClassification = useCallback((): void => {
    setCustomerClassification(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerClassification]);

  return {
    customerClassification,
    createCustomerClassification,
    onChangeCustomerClassification,
    deleteCustomerClassification,
  };
};
